import { Navigate, useRoutes } from "react-router-dom";
import { PATH_AFTER_LOGIN } from "src/config-global";
import { paths } from "src/routes/paths";
import { accountManagementRoutes } from "src/routes/sections/account-management";
import { authRoutes } from "src/routes/sections/auth";
import { operationsRoutes } from "src/routes/sections/operations";
import { pushNotificationsRoutes } from "src/routes/sections/push-notifications";
import { usersRoutes } from "src/routes/sections/users";
import { myAccountRoutes } from "./my-account";

export default function Router() {
  return useRoutes([
    {
      path: "/",
      element: <Navigate to={PATH_AFTER_LOGIN} replace />,
    },
    ...authRoutes,
    ...usersRoutes,
    ...operationsRoutes,
    ...pushNotificationsRoutes,
    ...accountManagementRoutes,
    ...myAccountRoutes,
    // No match 404
    { path: "*", element: <Navigate to={paths.error["404"]} replace /> },
  ]);
}
